import MensagensParaUsuarioFinal from 'utils/mensagensParaUsuarioFinal';
import { FuncionalidadePortalCliente } from 'constants/funcionalidadePortalCliente';

export function obterBloqueio(configuracao, funcionalidade) {
  const bloqueio = configuracao?.bloqueios
    ?.find(b => b.funcionalidade === funcionalidade);

  const termino = bloqueio?.termino ?? null;

  return {
    bloqueado: bloqueio?.ativo ?? false,
    termino,
    mensagem: MensagensParaUsuarioFinal.BloqueioFuncionalidade(termino),
  };
}

export function obterBloqueioAlteracaoPlano(configuracao) {
  const bloqueio = obterBloqueio(configuracao, FuncionalidadePortalCliente.AlteracaoPlanoUsuario);

  return {
    execucaoImediataBloqueada: bloqueio.bloqueado,
    entradaBloqueada: entradaAlteracaoPlanoBloqueada(bloqueio),
    termino: bloqueio.termino,
    mensagem: bloqueio.mensagem,
  };
}

export function entradaAlteracaoPlanoBloqueada({ bloqueado, termino }) {
  return bloqueado && janelaAlcancaProximoMes(termino);
}

function janelaAlcancaProximoMes(termino) {
  if (!termino) return false;

  const agora = new Date();
  const primeiroDiaProximoMes = new Date(agora.getFullYear(), agora.getMonth() + 1, 1);

  return new Date(termino) >= primeiroDiaProximoMes;
}
